//for ref
//https://www.youtube.com/watch?v=VUyBY72mwrQ&t=95s&ab_channel=Fireship

export const sharedText =  'sharedText to all apps Change'

// export default class myStrings {

//   sharedText =  'sharedText to all apps Change';

// }

